import { Component, OnInit } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen'
import { TranslationService } from './services/translate/translation.service';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {

  /**
   * @constructor
   * @param {TranslationService} _translation
   */
  constructor(
    private _translation: TranslationService
  ) { }
  
  /**
   * On Init
   * @returns {void}
   */
  ngOnInit(): void {
    this._translation.setLanguage();
    setTimeout(() => {
      SplashScreen.hide({
        fadeOutDuration: 250
      })
    }, 500);
  }
}
